"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
var _axios = _interopRequireDefault(require("axios"));
var _validate = require("@/utils/validate");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  filters: {
    isVirtualFormatter: function isVirtualFormatter(val) {
      var options = {
        'N': '',
        'R': '（路由）',
        'V': '（虚拟）'
      };
      return options[val];
    }
  },
  data: function data() {
    var _this = this;
    var validateFunctionName = function validateFunctionName(rule, value, callback) {
      if ((0, _validate.validRule1)(value)) {
        callback(new Error(_this.$t('functionList.error.functionName')));
      } else if (_this.errorKeys.indexOf('functionName') >= 0) {
        callback(new Error(_this.errorInfo['functionName']));
        _this.resetError('functionName');
      } else {
        callback();
      }
    };
    var validateFunctionCode = function validateFunctionCode(rule, value, callback) {
      if ((0, _validate.validRule3)(value)) {
        callback(new Error(_this.$t('functionList.error.functionCode')));
      } else if (_this.errorKeys.indexOf('functionCode') >= 0) {
        callback(new Error(_this.errorInfo['functionCode']));
        _this.resetError('functionCode');
      } else {
        callback();
      }
    };
    var validateFunctionBindNos = function validateFunctionBindNos(rule, value, callback) {
      if ((0, _validate.validRule2)(value)) {
        callback(new Error(_this.$t('functionList.error.functionBindNos')));
      } else if (_this.errorKeys.indexOf('functionBindNos') >= 0) {
        callback(new Error(_this.errorInfo['functionBindNos']));
        _this.resetError('functionBindNos');
      } else {
        callback();
      }
    };
    return {
      pageName: 'functionlist',
      formLabelWidth: '120px',
      loadingComponent: null,
      listLoading: false,
      isLoading: false,
      list: [],
      total: 0,
      currentId: null,
      isShowModel: false,
      currPage: 1,
      limit: 10,
      sourceApi: null,
      dialogStatus: 'create',
      form: {
        functionPk: '',
        menuPk: '',
        functionName: '',
        functionCode: '',
        functionBindNos: '',
        remark: ''
      },
      initForm: {
        functionPk: '',
        menuPk: '',
        functionName: '',
        functionCode: '',
        functionBindNos: '',
        remark: ''
      },
      rules: {
        functionName: [{
          required: true,
          trigger: ['change'],
          validator: validateFunctionName
        }],
        functionCode: [{
          required: true,
          trigger: ['change'],
          validator: validateFunctionCode
        }],
        functionBindNos: [{
          required: true,
          trigger: ['change'],
          validator: validateFunctionBindNos
        }]
      },
      errorKeys: [],
      errorInfo: {}
    };
  },
  computed: {
    menuName: function menuName() {
      return function (val) {
        return this.$t('functionList.table.menuName');
      };
    }
  },
  watch: {
    isLoading: function isLoading(newValue) {
      // pc unlock 锁屏会导致页面晃动
      if (newValue) {
        this.loadingComponent = this.$loading({
          // lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0)'
        });
      } else {
        if (this.loadingComponent) {
          this.loadingComponent.close();
        }
      }
    }
  },
  mounted: function mounted() {
    this.fetchData();
  },
  methods: {
    finalCellClassName: function finalCellClassName(_ref) {
      var row = _ref.row,
        column = _ref.column,
        rowIndex = _ref.rowIndex,
        columnIndex = _ref.columnIndex;
      // console.log(column, rowIndex, columnIndex)
      if (columnIndex === 1 || columnIndex === 2 || columnIndex === 3 || columnIndex === 4 || columnIndex === 5) {
        return 'no-padding-cell-warpper';
      }
    },
    tableIndex: function tableIndex(index) {
      return index + 1;
    },
    fetchData: function fetchData() {
      var _this2 = this;
      if (this.sourceApi) {
        this.sourceApi.cancel('cancel');
      }
      this.sourceApi = _axios.default.CancelToken.source();
      var param = {
        currPage: this.currPage,
        limit: this.limit
      };
      this.listLoading = true;
      this.$api.functionList.getList(param, this.sourceApi.token).then(function (res) {
        _this2.listLoading = false;
        _this2.list = res.data;
      }).catch(function (err) {
        if (_axios.default.isCancel(err)) {
          return false;
        }
        _this2.listLoading = false;
      });
    },
    refreshData: function refreshData() {
      this.fetchData();
    },
    resetError: function resetError(val) {
      if (val) {
        var index = this.errorKeys.indexOf(val);
        this.errorKeys.splice(index, 1);
        delete this.errorInfo.val;
      } else {
        this.errorKeys = [];
        this.errorInfo = {};
      }
    },
    create: function create(row) {
      var _this3 = this;
      this.dialogStatus = 'create';
      this.form = {
        functionPk: '',
        menuPk: row.menuPk,
        functionName: '',
        functionCode: '',
        functionBindNos: '',
        remark: ''
      };
      this.initForm = {
        functionPk: '',
        menuPk: row.menuPk,
        functionName: '',
        functionCode: '',
        functionBindNos: '',
        remark: ''
      };
      this.isShowModel = true;
      this.$nextTick(function () {
        _this3.$refs['dataForm'].clearValidate();
      });
    },
    edit: function edit(row) {
      var _this4 = this;
      this.dialogStatus = 'edit';
      this.currentId = row.functionPk;
      this.isShowModel = true;
      if (this.currentId === null) {
        return;
      }
      this.getDetail().then(function (res) {
        _this4.isShowModel = true;
        _this4.$nextTick(function () {
          _this4.$refs['dataForm'].clearValidate();
        });
      });
    },
    getDetail: function getDetail() {
      var _this5 = this;
      return new Promise(function (resolve) {
        _this5.isLoading = true;
        _this5.$api.functionList.getDetail(_this5.currentId).then(function (res) {
          _this5.isLoading = false;
          var _res$data = res.data,
            functionPk = _res$data.functionPk,
            menuPk = _res$data.menuPk,
            functionName = _res$data.functionName,
            functionCode = _res$data.functionCode,
            functionBindNos = _res$data.functionBindNos,
            remark = _res$data.remark;
          _this5.form = {
            functionPk: functionPk,
            menuPk: menuPk,
            functionName: functionName,
            functionCode: functionCode,
            functionBindNos: functionBindNos,
            remark: remark
          };
          _this5.initForm = {
            functionPk: functionPk,
            menuPk: menuPk,
            functionName: functionName,
            functionCode: functionCode,
            functionBindNos: functionBindNos,
            remark: remark
          };
          resolve(_this5.form);
        }).catch(function () {
          _this5.isLoading = false;
          console.log('Data Request Fail');
        });
      });
    },
    deleteItem: function deleteItem(row) {
      var _this6 = this;
      this.$confirm(this.$t('common.confirm1'), this.$t('common.tip'), {
        confirmButtonText: this.$t('common.confirm'),
        cancelButtonText: this.$t('common.cancel'),
        type: 'warning'
      }).then(function () {
        _this6.isLoading = true;
        _this6.$api.functionList.deleteItem([row.functionPk]).then(function (res) {
          _this6.isLoading = false;
          _this6.refreshData();
        }).catch(function () {
          _this6.isLoading = false;
        });
      }).catch(function () {});
    },
    shortCut: function shortCut(val) {
      switch (val) {
        case 'LIST':
          this.form.functionName = '列表查询 / 搜索';
          this.form.functionCode = 'LIST';
          break;
        case 'ADD_EDIT':
          this.form.functionName = '新增 / 编辑';
          this.form.functionCode = 'ADD_EDIT';
          break;
        case 'DETAIL':
          this.form.functionName = '详情';
          this.form.functionCode = 'DETAIL';
          break;
        case 'DELETE':
          this.form.functionName = '删除';
          this.form.functionCode = 'DELETE';
          break;
        case 'ENABLE_DISABLED':
          this.form.functionName = '启用 / 禁用';
          this.form.functionCode = 'ENABLE_DISABLED';
          break;
      }
    },
    saveItem: function saveItem() {
      var _this7 = this;
      this.$refs['dataForm'].clearValidate();
      this.$refs.dataForm.validate(function (valid) {
        if (!valid) return;
        _this7.isLoading = true;
        _this7.$api.functionList.saveItem(_this7.form).then(function (res) {
          _this7.isLoading = false;
          _this7.isShowModel = false;
          _this7.refreshData();
        }).catch(function (err) {
          if (err.errorInfos && err.errorInfos.length > 0) {
            _this7.resetError();
            err.errorInfos.forEach(function (item) {
              _this7.errorKeys.push(item.key);
              _this7.errorInfo[item.key] = item.errMsg;
            });
            _this7.$refs['dataForm'].validate(function (valid) {
              console.log(valid);
            });
          }
          _this7.isLoading = false;
          // this.$message.error('保存失败')
        });
      });
    }
  }
};